import * as dotProp from 'dot-prop-immutable';
import * as types from '../../constants/subscriptionSearch';

const INITIAL_STATE = {
  orders: {},
};

export const subscriptionOrders = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_SUBSCRIPTION_ORDERS:
      return dotProp.set(state, 'orders', action.orders);
    default:
      return state;
  }
};

const subscriptionOrdersReducerWrapper = (state, action) => {
  return subscriptionOrders(state, action);
};

export default subscriptionOrdersReducerWrapper;
